import React, { createContext, useContext, useState, useEffect } from 'react';
import { getEntity } from '@/utils/handleToken';
import { usePathname, useRouter } from 'next/navigation';

interface EntityContextType {
	entities: number[];
	selectedEntity: number | null;
	setSelectedEntity: (entity: number) => void;
}

const EntityContext = createContext<EntityContextType | undefined>(undefined);

export const EntityProvider = ({ children }: { children: React.ReactNode }) => {
	const [entities, setEntities] = useState<number[]>([]);
	const [selectedEntity, setSelectedEntity] = useState<number | null>(null);
	const pathname = usePathname();

	const fetchEntities = () => {
		if (typeof window !== 'undefined') {
			const userEntities = getEntity();
			// console.log({ userEntities });
			setEntities(userEntities);

			// Jika hanya ada 1 entity, langsung set sebagai selected
			if (userEntities.length === 1) {
				setSelectedEntity(userEntities[0] ?? 0);
			}
		}
	};

	useEffect(() => {
		fetchEntities();
	}, [pathname]);  // ni trigger jalan ketika url berubah

	return (
		<EntityContext.Provider
			value={{ entities, selectedEntity, setSelectedEntity }}
		>
			{children}
		</EntityContext.Provider>
	);
};

export const useEntity = () => {
	const context = useContext(EntityContext);
	if (undefined === context) {
		throw new Error('useEntity must be used within an EntityProvider');
	}
	return context;
};
